var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"title":_vm.$t('pages.ssr_features.pages.common.more_features.privacy.title'),"description":_vm.$t('pages.ssr_features.pages.common.more_features.privacy.description'),"icon-name":"Privacy","link-url":_vm.$locatedLink('/features/privacy')}})
}
var staticRenderFns = []

export { render, staticRenderFns }